<style lang="scss" scoped>
.navbar-container {
  position: absolute;
  top: 0;
  padding: 20px 0px;
  height: 80px;
  .navbar-dropdown {
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>
<template>
  <div class="bg-primary align-content-center justify-content-center d-flex">
    <div class="container navbar-container">
      <div class="row" v-if="user">
        <el-navbar-dropdown class="col-3 ml-auto" :min="user.workspace_ids.length === 0" />
      </div>
    </div>
    <page-box>
      <template>
        <div class="w-100 align-items-center d-none d-md-flex">
          <i-logo class="i-logo mx-auto mb-15"></i-logo>
        </div>
        <router-view />
      </template>
    </page-box>
  </div>
</template>

<script>
import ElNavbarDropdown from '@/components/general/navbar-dropdown';

/*
| Onboarding index
| ------------------
| The page index container contaienr
| for all guest users
*/
export default {
  name: 'group-onboarding',

  components: { ElNavbarDropdown },

  computed: {
    user() {
      return this.$store.getters['auth/user'];
    },
  },
};
</script>
